import React from 'react';
 import { Link } from 'react-router-dom';
import './PopularCourses.css';
import mathimg from "../assets/MathImg.png";
import codingimg from "../assets/CodingImg.png";
import graphicimg from "../assets/GraphicImg.png";
import quranimg from "../assets/QuranImg.png";
import businessimg from "../assets/BusinessImg.png";
import spaceimg from "../assets/SpaceImg.png";
import communicationimg from "../assets/CommunicationImg.png";
import architectureimg from "../assets/ArchitectureImg.png";
import engineeringimg from "../assets/EngineeringImg.png";

const PopularCourses = () => {
  const courses = [
    {
      id: 1,
      title: "Math's Portal",
      image: mathimg,
      // bgColor: "#FF3366",
      link: "/math"
    },
    {
      id: 2,
      title: "Coding & Technology",
      image: codingimg,
      // bgColor: "#9933FF",
      link: "/coding"
    },
    {
      id: 3,
      title: "Graphic Design & Creativity",
      image: graphicimg,
      // bgColor: "#33B5E5",
      link: "/graphic-design"
    },
    {
      id: 4,
      title: "Quran & Islamic Studies",
      image: quranimg,
      // bgColor: "#00C851",
      link: "/quran"
    },
    {
      id: 5,
      title: "Business & Entrepreneurship",
      image: businessimg,
      // bgColor: "#FF8800",
      link: "/business"
    },
    {
      id: 6,
      title: "Engineering & Technology",
      image: engineeringimg,
      // bgColor: "#2BBBAD",
      link: "/engineering"
    },
    {
      id: 7,
      title: "Architecture & Interior Design",
      image: architectureimg,
      // bgColor: "#E91E63",
      link: "/architecture"
    },
    {
      id: 8,
      title: "Communication & Public Speaking",
      image: communicationimg,
      // bgColor: "#4285F4",
      link: "/communication"
    },
    {
      id: 9,
      title: "Space Sciences",
      image: spaceimg,
      // bgColor: "#AA66CC",
      link: "/space-sciences"
    }
  ];

  return (
    <div className="stem-container">
      <h1 className="stem-title">Our Popular Stem Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.id} className="course-card">
            <Link to={course.link} className="course-link">
              <div className="course-image-container">
                <img 
                  src={course.image} 
                  alt={course.title}
                  className="course-image"
                />
              </div>
              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="demo-button">Book a free demo lesson</button>
    </div>
  );
};

export default PopularCourses;